import apiClient from './config';

// Crear una cita desde el formulario público
export const crearCitaPublica = (citaData) => {
  return apiClient.post('/citas/publica', citaData);
};

// Obtener citas desde el panel de administración (requiere autenticación)
export const obtenerCitas = (params) => {
  return apiClient.get('/citas', { params });
};

// Crear cita desde panel del doctor (requiere autenticación)
export const crearCita = (data) => {
  return apiClient.post('/citas', data);
};

// Obtener citas específicas del doctor autenticado (ruta actual filtra automáticamente)
export const obtenerCitasDoctor = (params) => {
  return apiClient.get('/citas', { params });
};

// Obtener detalles de una cita específica (requiere autenticación)
export const obtenerCita = (citaId) => {
  return apiClient.get(`/citas/${citaId}`);
};

// Actualizar el estado de una cita (requiere autenticación)
export const actualizarEstadoCita = (citaId, data) => {
  return apiClient.put(`/citas/${citaId}/estado`, data);
};

// Actualizar el pago de una cita (requiere autenticación)
export const actualizarPago = (citaId, data) => {
  const formData = new FormData();
  
  // Agregar datos básicos
  Object.keys(data).forEach(key => {
    if (data[key] !== null && data[key] !== undefined) {
      formData.append(key, data[key]);
    }
  });
  
  // Agregar comprobante si existe
  if (data.comprobante && data.comprobante instanceof File) {
    formData.append('comprobante', data.comprobante);
  }
  
  return apiClient.put(`/citas/${citaId}/pago`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// Obtener disponibilidad para una fecha específica (requiere autenticación)
export const obtenerDisponibilidad = (fecha) => {
  return apiClient.get('/citas/disponibilidad', { params: { fecha } });
};

// Obtener disponibilidad pública para una fecha y doctor específicos (accesible sin autenticación)
export const obtenerDisponibilidadPublica = (doctorId, fecha) => {
  return apiClient.get('/citas/disponibilidad-publica', { 
    params: { 
      doctorId,
      fecha: fecha instanceof Date ? fecha.toISOString().split('T')[0] : fecha,
      soloDisponibles: true
    } 
  });
};